export default __webpack_public_path__ + "static/media/5_2.74c484b6.jpg";